import React from 'react'
import { Layout, Menu, Typography, Space, Avatar, Dropdown } from 'antd'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { UserOutlined, HomeOutlined, FileTextOutlined, BookOutlined, SettingOutlined, LogoutOutlined, DashboardOutlined } from '@ant-design/icons'

const { Header, Content, Sider } = Layout
const { Title } = Typography

const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user, logout, hasRole } = useAuth()

  const menuItems: any[] = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: '首页',
    },
    {
      key: '/case/new',
      icon: <FileTextOutlined />,
      label: '案件录入',
    },
  ]

  if (hasRole('staff') || hasRole('admin')) {
    menuItems.push({
      key: '/staff/receptions',
      icon: <DashboardOutlined />,
      label: '接访管理',
    })
  }

  if (hasRole('admin')) {
    menuItems.push(
      {
        key: '/admin/rules',
        icon: <BookOutlined />,
        label: '规则管理',
      },
      {
        key: '/admin/users',
        icon: <SettingOutlined />,
        label: '用户管理',
      },
      {
        key: '/admin/audits',
        icon: <DashboardOutlined />,
        label: '审计日志',
      }
    )
  }

  const userMenu = {
    items: [
      {
        key: 'logout',
        icon: <LogoutOutlined />,
        label: '退出登录',
        onClick: () => logout(),
      },
    ],
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider width={250} theme="dark">
        <div style={{ 
          height: 64, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          background: '#001529'
        }}>
          <Title level={4} style={{ color: 'white', margin: 0 }}>智能接访系统</Title>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>
      <Layout>
        <Header style={{ 
          background: 'white', 
          padding: '0 24px',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          boxShadow: '0 2px 8px #f0f1f2'
        }}>
          <Dropdown menu={userMenu}>
            <Space style={{ cursor: 'pointer' }}>
              <Avatar icon={<UserOutlined />} />
              <span>{user?.real_name || user?.username}</span>
              <span style={{ color: '#999' }}>({user?.role})</span>
            </Space>
          </Dropdown>
        </Header>
        <Content style={{ margin: '24px 16px', padding: 24, background: 'white' }}>
          {children}
        </Content>
      </Layout>
    </Layout>
  )
}

export default AppLayout
